export class HandbookFilter {
  page: number = 1;
  size: number = 15;
  serviceCode?: string | null = null;
  deleted?: boolean | null = null;

  id?: number | null;
  name?: string | null;
}
